import { PageWrapper } from "../components/PageWrapper";
import Titlebar, { TitlebarAction } from "../components/Titlebar";
import { useAgGridUtils } from "../utils/gridUtils";
import { CreateUserModal } from "./components/CreateUserModal";
import { useCreateUserForm } from "./components/CreateUserModal/hooks";
import { UserDetails } from "./components/UserDetails";
import { UsersTable } from "./components/UsersTable";
import { useSlideoutDrawer } from "./components/UsersTable/hooks/useSlideoutDrawer";
import { useFetchUsers, useDownloadAuditLog } from "./hooks";

const UsersPage: React.FC = () => {
  const { response, userRows } = useFetchUsers();
  const { onGridReady, resetFilters, gridApi, isFilterPresent, onFilterChanged } =
    useAgGridUtils();
  const { onRowClicked, userId, onClose, setUserId } = useSlideoutDrawer();
  const {
    showModal,
    onHide,
    openModal,
    initialValues,
    onSubmit,
    isSubmitting,
    roleOptions,
    useGetGroupsQueryResult,
  } = useCreateUserForm(setUserId);
  const { downloadAuditLog, loading: downloadLoading } = useDownloadAuditLog();

  const actionButtons: TitlebarAction[] = [
    {
      show: isFilterPresent,
      buttonProps: {
        variant: "neutral",
        icon: "times",
        key: "clear_filters",
        onClick: resetFilters,
        children: "Clear filters",
      },
    },
    {
      show: true,
      buttonProps: {
        variant: "neutral",
        icon: "download",
        key: "download_audit_log",
        onClick: downloadAuditLog,
        children: "Download audit log",
        isLoading: downloadLoading,
        disabled: downloadLoading,
      },
    },
    {
      show: true,
      buttonProps: {
        variant: "primary",
        icon: "plus",
        key: "add_new_user",
        onClick: openModal,
        children: "Add new user",
      },
    },
  ];

  return (
    <PageWrapper result={response} testId="users-page">
      <Titlebar marginBottom="md" variant="h2" title="Users" actionButtons={actionButtons} />
      <UsersTable
        onGridReady={onGridReady}
        userRows={userRows}
        onRowClicked={onRowClicked}
        gridApi={gridApi}
        onFilterChanged={onFilterChanged}
      />
      <UserDetails userId={userId} onClose={onClose} />
      <CreateUserModal
        show={showModal}
        onHide={onHide}
        initialValues={initialValues}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        roleOptions={roleOptions}
        useGetGroupsQueryResult={useGetGroupsQueryResult}
      />
    </PageWrapper>
  );
};

export default UsersPage;
